@import '~style-sheet-helpers/core';
@import '../../../app-brand/entities/entity-layer.module.less';
@import 'ui-components/components/DEPRECATED/tabs/tab-button/tab-button.module.less';
@import '../../../constants/spacing.module.less';

@app-header-height: 40px;
@breadcrumbs-height: 45px;
@paging-height: 42px;
@header-height: 100px;
@tabs-height: 41px;
@controls-group-height: 48px;

@view-height-remaining: calc(
  100vh - (@paging-height + @header-height + @breadcrumbs-height + @app-header-height + @tabs-height + @controls-group-height)
);

.sub-page {
  display: grid;
  grid-template-rows: 100px auto;
  width: 100%;
  height: calc(100vh - (@breadcrumbs-height + @app-header-height));
  align-content: baseline;
}

.transaction-history-page-header {
  padding: @space-0 @space-24;
}

.controls-group {
  padding: 8px 0 8px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  > div > :not(:first-child) {
    padding-left: 24px;
  }
}

.tabs {
  display: flex;
  border-bottom: 1px solid @tabs--tabs-header--border-bottom-color;
  width: 100%;
}

.tab-link {
  height: 40px;
  line-height: 34px;
  font-size: 14px;
  color: @tabs--tab-button--text-color;

  @file-tab();
  &:focus {
    background-color: @tabs--file-tab-button--selected--background-color;
  }
}

.active-tab-link {
  @selected-file-tab();
}

.table {
  min-height: @view-height-remaining;
  user-select: auto;
  overflow: scroll;
}

.header-background,
.row-background {
  border-bottom: 1px solid @hooks-display-grid--row--border-color;
  font-size: 14px;
  line-height: 30px;
  padding-left: 16px;
}

.header-background {
  position: sticky;
  top: 0;
  background-color: @hooks-display-grid--header--background-color;
  border-top: 1px solid @hooks-display-grid--header--border-color;
  height: 32px;
  color: @hooks-display-grid--header-row--text-color;
  z-index: 2;
}

.cell {
  padding: 0 8px;
}

.header-cell {
  background-color: @hooks-display-grid--header--background-color;
  padding-left: 8px;
}

.header-divider {
  float: right;
  width: 8px;
  height: 100%;
  border-right: 1px solid @hooks-display-grid--header-row--border-color;
}

.row {
  background-color: @hooks-display-grid--row--background-color;

  &:hover {
    background: @hooks-display-grid--row--hover--background-color;
  }
}

.currency {
  text-align: right;
}

.button-link {
  font-size: 14px;
  padding-right: 16px;
}

.date-range-toggler {
  color: @actionable-filter-pill--bar--text-color;
  padding-left: 24px;

  svg {
    fill: @actionable-filter-pill--bar--text-color;
  }
}
